module.exports = __webpack_public_path__ + "static/media/iconmonstr-arrow-65.d268e4e3.svg";